module.exports = __webpack_public_path__ + "img/11_2024_08_23.f5580623.jpg";